export const ProviderHelperClient = {
  getEnvVariable(providerKey: string, key: string, valueDefault?: string) {
    const keyBuilt = `VITE_PROVIDER_${providerKey?.toUpperCase()}_${key}`

    const value = import.meta.env[keyBuilt] ?? valueDefault

    return value
  },
}
